var map = {
  "./cs.json": [
    "TxE",
    [
      "tb"
    ]
  ],
  "./en.json": [
    "qt",
    [
      83
    ]
  ],
  "./pl.json": [
    "VHM",
    [
      "zg"
    ]
  ],
  "./ru.json": [
    "BL",
    [
      "va"
    ]
  ],
  "./tr.json": [
    "vc0",
    [
      "la"
    ]
  ],
  "./ja.json": [
    "EVS",
    [
      "mx"
    ]
  ],
  "./zh.json": [
    "z9",
    [
      "pt"
    ]
  ],
  "./pt-br.json": [
    "YW",
    [
      "ya8"
    ]
  ],
  "./de.json": [
    "zRq",
    [
      "hh5"
    ]
  ],
  "./es.json": [
    "ZmX",
    [
      "3y"
    ]
  ],
  "./fr.json": [
    "b75",
    [
      1
    ]
  ],
  "./it.json": [
    "qQ",
    [
      "08g"
    ]
  ],
  "./ko.json": [
    "MP",
    [
      "igf"
    ]
  ],
  "./pt.json": [
    "B8",
    [
      "f5"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "NA";
module.exports = __rspack_async_context;
